/**
 * Memory Lane brand primitives — from the official Figma Brand Kit (Jun 2026).
 * Logo: lowercase "memory lane" wordmark with the journey-line motif.
 * JourneyLine: the recurring flowing-path motif (warm blue, dashed legs,
 * waypoint dots, arrow tip) used across heroes, footers, and dividers.
 */
import React from "react";

export const BrandLogo = ({ className = "h-8", alt = "Memory Lane" }) => (
    <img src="/brand/memory-lane-lockup.png" alt={alt} className={`w-auto ${className}`} draggable="false" />
);

/* Hero/heading-size version of the same lockup for big-heading moments. */
export const BrandLogoPrimary = ({ className = "h-10", alt = "Memory Lane" }) => (
    <img src="/brand/memory-lane-lockup.png" alt={alt} className={`w-auto ${className}`} draggable="false" />
);

export const JourneyLine = ({ className = "", width = 220, opacity = 1 }) => (
    <svg
        aria-hidden="true"
        className={className}
        width={width}
        viewBox="0 0 220 44"
        fill="none"
        style={{ opacity }}
    >
        <circle cx="6" cy="30" r="3.5" fill="#4F7F95" />
        <path
            d="M10 30 C 38 41, 62 40, 92 31 C 122 22, 148 15, 172 19 C 190 22, 202 28, 211 23"
            stroke="#4F7F95"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path d="M211 23 l-7.5 -1 M211 23 l-3 6.5" stroke="#4F7F95" strokeWidth="2" strokeLinecap="round" />
        <path d="M42 15 h32" stroke="#7FA3B5" strokeWidth="2" strokeDasharray="4 6" strokeLinecap="round" />
        <circle cx="37" cy="15" r="2.5" fill="#5B93AE" />
        <circle cx="80" cy="15" r="2.5" fill="#5B93AE" />
        <path d="M122 40 h38" stroke="#8FB5A8" strokeWidth="2" strokeDasharray="4 6" strokeLinecap="round" />
        <circle cx="117" cy="40" r="2.5" fill="#12776F" />
        <circle cx="166" cy="40" r="2.5" fill="#1D8A85" />
    </svg>
);
